import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=c2b16c38&scoped=true&"
import script from "./NewsView.vue?vue&type=script&lang=js&"
export * from "./NewsView.vue?vue&type=script&lang=js&"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=c2b16c38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b16c38",
  null
  
)

export default component.exports